export function update(id, data) {
    return {
        type: 'PARTICIPANT_DATA',
        data,
        id
    };
}

export function bulk(data) {
    return {
        type: 'PARTICIPANTS_DATA',
        data
    };
}

export function addToSportCollection(sportId, participant) {
    return {
        type: 'PARTICIPANT_COLLECTION_ADD',
        sportId,
        participant
    };
}
